import { KoinWorksSupportedLocation } from 'pages/Capital/ApplicationForm/DetailForm/KoinworksV2Form/types';
import { CHECK_KOINWORKS_STATUS } from '../constants';
import {
  PAGE_REQUEST_CAPITAL,
  SET_PERMISSION_STATE,
  REQUEST_ALLOWED_PERMISSION,
  PAGE_REQUEST_DASHBOARD,
  SET_DASHBOARD_LIST,
  PAGE_REQUEST_RESULT,
  SET_APPROVAL,
  SEND_SIGNIN_CONTRACT_CLICK,
  CHANGE_PAGE_APLICATION,
  SET_BORROWER_PROFILE,
  MOKA_CAPITAL_SET_LOAN_PERIOD,
  MOKA_CAPITAL_ON_CLICK_APPLY_LOAN_LIST,
  MOKA_CAPITAL_SUBMIT_FORM_CAPITAL,
  MOKA_CAPITAL_SET_PAGE,
  MOKA_CAPITAL_SET_ALLOW_TO_APPLY,
  MOKA_CAPITAL_SENDING_REQUEST,
  SHOW_ERROR_NOTIFICATION,
  SET_TO_REDUCER_BY_FIELDNAME,
  CHANGE_CAPITAL_TAB,
  GET_KOINWORKS_SUPPORTED_LOCATIONS,
  SET_KOINWORKS_SUPPORTED_LOCATIONS,
  MOKA_CAPITAL_SUBMIT_KOINWORKSV2_FORM,
} from './constants';

export function setToReducer(fieldName, value) {
  return { type: SET_TO_REDUCER_BY_FIELDNAME, payload: { fieldName, value } };
}

export function showErrorNotification(message?) {
  return { type: SHOW_ERROR_NOTIFICATION, payload: message };
}

export function pageRequest(payload?) {
  return { type: PAGE_REQUEST_CAPITAL, payload };
}

export function setBorrowerProfile(params) {
  return { type: SET_BORROWER_PROFILE, payload: { borrowerProfile: params } };
}

export function setPermissionsState(params) {
  return {
    type: SET_PERMISSION_STATE,
    payload: { setPermissionsState: params },
  };
}

export function allowPermission() {
  return { type: REQUEST_ALLOWED_PERMISSION, payload: {} };
}

export function pageRequestDashboard(payload) {
  return { type: PAGE_REQUEST_DASHBOARD, payload };
}

export function setDashboardList(params) {
  return { type: SET_DASHBOARD_LIST, payload: { dashboard: params } };
}

export function pageRequestResult(borrowerProfile) {
  return { type: PAGE_REQUEST_RESULT, payload: { borrowerProfile } };
}

export function setApprovals(params) {
  return { type: SET_APPROVAL, payload: { approvals: params } };
}

export function sendSignInContractClick(param, previousList) {
  return {
    type: SEND_SIGNIN_CONTRACT_CLICK,
    payload: { documentId: param, previousList },
  };
}

export function changePageApplication(page) {
  return { type: CHANGE_PAGE_APLICATION, payload: { applicationPage: page } };
}

export function setLoanPeriod(loanPeriod) {
  return { type: MOKA_CAPITAL_SET_LOAN_PERIOD, payload: { loanPeriod } };
}

export function clickApplyLoanList(params) {
  return {
    type: MOKA_CAPITAL_ON_CLICK_APPLY_LOAN_LIST,
    payload: { loan: params },
  };
}

export function submitFormCapital(params) {
  return { type: MOKA_CAPITAL_SUBMIT_FORM_CAPITAL, payload: { form: params } };
}

export function setCapitalPage(capitalPage) {
  return { type: MOKA_CAPITAL_SET_PAGE, payload: { capitalPage } };
}

export function setAllowToApply(isAllowToApply) {
  return { type: MOKA_CAPITAL_SET_ALLOW_TO_APPLY, payload: { isAllowToApply } };
}

export function sendingRequest(sendingRequestPayload) {
  return {
    type: MOKA_CAPITAL_SENDING_REQUEST,
    payload: { sendingRequest: sendingRequestPayload },
  };
}

export function changeCapitalTab(tabId) {
  return {
    type: CHANGE_CAPITAL_TAB,
    payload: { tabId },
  };
}

export * from './fastLoan';
export * from './investment';

export function setKoinworksSupportedLocations(
  supportedLocations: KoinWorksSupportedLocation[],
  section: string
) {
  return {
    type: SET_KOINWORKS_SUPPORTED_LOCATIONS,
    payload: { supportedLocations, section },
  };
}

export function getKoinworksSupportedLocations(
  postalCode: string,
  section: string
) {
  return {
    type: GET_KOINWORKS_SUPPORTED_LOCATIONS,
    payload: { postalCode, section },
  };
}

export function checkKoinWorksStatus(onNotAllowedToFillForm: Function) {
  return {
    type: CHECK_KOINWORKS_STATUS,
    payload: onNotAllowedToFillForm,
  };
}

export function submitKoinWorksV2Form(form) {
  return {
    type: MOKA_CAPITAL_SUBMIT_KOINWORKSV2_FORM,
    payload: form,
  };
}
